/* eslint-disable import/first */
import React from 'react';
import noOffer from './images/NoOffers.png';
import { Grid, Button, Typography } from '@material-ui/core';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';

const NoOffer = ({ callback }) => {
  return (
    <Grid className={css.noOfferContainer}>
      <Grid>
        <img src={noOffer} alt="" />
      </Grid>
      <Grid className={css.text}>
        <Typography>
          <FormattedMessage id="no_offers" defaultMessage="No Deals & Offers!" />
        </Typography>
      </Grid>
      <Grid className={css.text2}>
        <Typography>
          <FormattedMessage id="no_offers_subtitle" />
        </Typography>
      </Grid>
      <Button
        className={css.button}
        variant="contained"
        size="large"
        color="primary"
        onClick={callback}
      >
        <FormattedMessage id="explore_menu" defaultMessage="Explore Menu" />
      </Button>
    </Grid>
  );
};

export default NoOffer;
